import { createSelector } from '@opengov/compose-app/reselect';
import { wizardSelector } from '../state';
export var selectWizardState = createSelector(wizardSelector, function (wizardState) {
  return wizardState;
});
export var selectActiveStepIndex = createSelector(wizardSelector, function (wizardState) {
  return wizardState.activeStepIndex;
});
export var selectNumberOfSteps = createSelector(wizardSelector, function (wizardState) {
  return wizardState.numberOfSteps;
});
export var selectIsOnLastStep = createSelector(wizardSelector, function (wizardState) {
  return wizardState.isOnLastStep;
});